module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"live":"【Live】"},"zh":{"live":"【直播】"}}')
  delete Component.options._Ctor
}
